// extracted by mini-css-extract-plugin
export default {"icon":"Button_icon__e2ifq","reverse":"Button_reverse__zk4rR"};